import React from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Outlet } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";

const Dashboard = () => {
  const { logOutUser } = useAuth();
  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto">
        <div className="text-center">
          <div className="flex items-center justify-center relative">
            <Link to="/">
              <div className="absolute left-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              </div>
            </Link>

            <h2 className="text-3xl font-semibold">Welcome to Dashboard</h2>
            <div
              onClick={() => logOutUser()}
              className="absolute right-10 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 17l5-5-5-5M19.8 12H9M13 22a10 10 0 1 1 0-20" />
              </svg>
            </div>
          </div>
          <div className="mt-6 flex justify-center items-center gap-3">
            <NavLink
              to="/admin-dashboard"
              className={(active) =>
                `text-white p-3 block transition-all rounded-sm ${
                  active.isActive ? "bg-gray-800" : "bg-gray-900  "
                }`
              }
            >
              Add Projects
            </NavLink>
            <NavLink
              to="/admin-dashboard/add-blogs"
              className={(active) =>
                `text-white p-3 block transition-all rounded-sm ${
                  active.isActive ? "bg-gray-800" : "bg-gray-900  "
                }`
              }
            >
              Add blogs
            </NavLink>
          </div>
        </div>
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
